// import ChartDataLabels from './display-min-max-value-plugin-src';
// TODO: Upgrade this library and chartjs

const ChartDataLabels = null;

/**
 * ChartDataLabels is the official plugin of chartjs
 * but it has a serious issue
 * it registers the plugin globally
 * we have to copy the code and remove the global register
 */
export const DisplayMinMaxValuePlugin = () => ChartDataLabels;

export const pluginDisplayer = (ctx) => {
  const currentPointValue = ctx.dataset.data[ctx.dataIndex];
  const maxValue = Math.max(...ctx.dataset.data);
  const minValue = Math.min(...ctx.dataset.data);
  const isMinOrMax =
    currentPointValue === maxValue || currentPointValue === minValue;
  if (isMinOrMax) {
    for (let i = 0; i < ctx.dataIndex; i++) {
      if (ctx.dataset.data[i] === currentPointValue) return false;
    }
  }
  return isMinOrMax;
};

export const lineChartOffsetter = (ctx) => {
  const currentPointValue = ctx.dataset.data[ctx.dataIndex];
  const maxValue = Math.max(...ctx.dataset.data);
  return currentPointValue === maxValue ? 4 : -28;
};

export const pluginFont = {
  size: 14,
  family: 'Nunito Sans',
  weight: 'normal',
  lineHeight: 1,
  style: 'normal',
};
